import { createActions, createReducer } from 'reduxsauce'

import EventosLicitacaoService from '../../servicos/EventosLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEventosLicitacaoInicio: [],
    buscaEventosLicitacaoSucesso: ['eventosLicitacao'],
    buscaEventosLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaEventosLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEventosLicitacaoInicio())
        let serv = new EventosLicitacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaEventosLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEventosLicitacaoErro(error)))
    }
}

const buscaEventosLicitacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaEventosLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaEventosLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.eventosLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EVENTOS_LICITACAO_INICIO]: buscaEventosLicitacaoInicio,
    [Types.BUSCA_EVENTOS_LICITACAO_ERRO]: buscaEventosLicitacaoErro,
    [Types.BUSCA_EVENTOS_LICITACAO_SUCESSO]: buscaEventosLicitacaoSucesso,
})
